import React from "react";
import { useDispatch } from "react-redux";
import MediaQuery from "react-responsive";
import { useTranslation } from "react-i18next";

import ParallaxRow from "../../components/parallax-row/parallax-row.component";
import PrimaryButton from "../primary-button/primary-button.component";
import MenuButton from "../menu-button/menu-button.component";
import Enter from "../../components/enter/enter.component";
import { scrollToSection } from "../../redux/nav/nav.actions";

import homeImage from "../../assets/TFE_desktop_homepage_image.jpg";
import homeImageMobile from "../../assets/TFE_mobile_homepage_image.jpg";
import "./home.styles.scss";

const Home: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <div className="home">
      <MediaQuery maxWidth={750}>
        {(matches) => (
          <ParallaxRow
            background={matches ? homeImageMobile : homeImage}
            alt={t("home.backgroundAlt")}
          />
        )}
      </MediaQuery>
      <div className="menu-button-header">
        <MenuButton inverted />
      </div>
      <Enter enterStyle="fade-up" duration="1000ms">
        <div className="center">
          <div className="logo-container">
            <img
              alt={t("home.logoAlt")}
              className="logo-image"
              src={`${process.env.PUBLIC_URL}/TFE_white_logo.svg`}
              width="3581"
              height="987"
              loading="eager"
              fetchPriority="high"
              decoding="async"
            />
          </div>
          <PrimaryButton
            large
            onClick={() => dispatch(scrollToSection("Contact"))}
          >
            {t("common.bookNow")}
          </PrimaryButton>
        </div>
      </Enter>
      <div className="scroll-message">
        <span>{t("home.scrollDown")}</span>
      </div>
    </div>
  );
};

export default Home;
